import { Platform, ShareOptions } from 'react-native'

import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

// import Share, { ShareSingleOptions } from 'react-native-share'

interface WhatsappShareProps {
  isWhatsapp: true
  phoneNumber: string
  base64Image: string
  message: string
}

interface NativeShareProps {
  isWhatsapp?: false
  base64Image: string
  message: string
}

const WHATSAPP_PACKAGE_ID = 'com.whatsapp'
const WHATSAPP_FOR_BUSINESS_PACKAGE_ID = 'com.whatsapp.w4b'

type WhatsappType = 'WHATSAPP' | 'WHATSAPP_FOR_BUSINESS' | undefined
let whatsappType: WhatsappType

type Toast = ReturnType<typeof useToast>

const USER_SHARE_CANCEL_ERROR = 'User did not share'

async function isWhatsappInstalled() {
  if (Platform.OS === 'android') {
    try {
      const { isInstalled } = await Share.isPackageInstalled(
        WHATSAPP_PACKAGE_ID
      )
      if (isInstalled) {
        whatsappType = 'WHATSAPP'
        return true
      }
    } catch (e) {
      /* empty */
    }
    try {
      const { isInstalled } = await Share.isPackageInstalled(
        WHATSAPP_FOR_BUSINESS_PACKAGE_ID
      )
      if (isInstalled) {
        whatsappType = 'WHATSAPP_FOR_BUSINESS'
        return true
      }
    } catch (e) {
      /* empty */
    }
  }
  return false
}

async function shareToApp(
  props: WhatsappShareProps | NativeShareProps,
  toast?: Toast
) {
  try {
    if (props.isWhatsapp) {
      await whatsappShare(props)
    } else {
      await nativeShare(props)
    }
  } catch (e: any) {
    if (e.message !== USER_SHARE_CANCEL_ERROR) {
      handleShareError(toast)
    }
  }
}

async function whatsappShare(props: WhatsappShareProps) {
  const { phoneNumber, base64Image, message } = props
  const shareConfig = {
    message,
    url: base64Image,
    social:
      whatsappType === 'WHATSAPP_FOR_BUSINESS'
        ? Share.Social.WHATSAPPBUSINESS
        : Share.Social.WHATSAPP,
    ...(phoneNumber && {
      whatsAppNumber:
        phoneNumber?.toString()?.length > 10
          ? phoneNumber?.toString()
          : `91${phoneNumber}`,
    }),
  } as ShareSingleOptions
  await Share.shareSingle(shareConfig)
}

async function nativeShare(props: NativeShareProps) {
  const { base64Image, message } = props

  const shareConfig = {
    message: message,
    url: base64Image,
  } as ShareOptions

  await Share.open(shareConfig)
}

function handleShareError(toast?: Toast) {
  toast?.show({
    intent: 'error',
    heading: i18n.t('toastMessages.error'),
    description: i18n.t('toastMessages.somethingWentWrong'),
    hideAfter: 3000,
  })
}

export { isWhatsappInstalled, nativeShare, shareToApp }
